import {
  platformEventBus,
  type PlatformEventHandler,
} from '@/platform/events/EventBus';

export function subscribeToPlatformEvents(
  handler: PlatformEventHandler,
): () => void {
  return platformEventBus.subscribe(handler);
}
